import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    phone: String
  }

  open(event) {
    event.preventDefault()

    const phone = this.phoneValue
    const appLink = `whatsapp://send?phone=${phone}`
    const webLink = `https://wa.me/${phone}`

    // Tente d'ouvrir l'application mobile
    window.location.href = appLink

    // Si rien ne se passe après 1 seconde, redirige vers WhatsApp Web
    setTimeout(() => {
      window.open(webLink, "_blank")
    }, 1000)
  }
}
